export default function getLocalStorageItem(
  itemKey,
  returnValueIfNull = null,
  returnValueOnError = returnValueIfNull,
  mustRemoveAfterReading = false
) {
  if (typeof window !== 'undefined') {
    const validatedItemKey = `${itemKey}`;
    try {
      const itemValue = window.localStorage.getItem(validatedItemKey);
      if (!!itemValue) {
        if (mustRemoveAfterReading) {
          window.localStorage.removeItem(validatedItemKey);
        }
        return JSON.parse(itemValue);
      }
      else {
        return returnValueIfNull;
      }
    }
    catch(error) {
      console.error(error);
      return returnValueOnError;
    }
  }
  else {
    return returnValueOnError;
  }
}
